import OptionImage from './OptionImage'

export default OptionImage
